/**
 * 분양광고 로테이터 — 순수 함수(브라우저 코드 PaidAdClient 가 쓴다 · 테스트 대상).
 *  · 넘김 조건(WCAG 2.2.2 · 노출 품질): 배너가 화면에 50% 이상 «1초 넘게 계속» 보일 때만 · 탭이 숨겨지면 멈춤 ·
 *    «동작 줄이기»(prefers-reduced-motion) 설정이면 자동 넘김을 켜지 않음(화면에 멈춤 버튼은 두지 않는다).
 *  · 시작 소재: 진입마다 무작위.
 */

import { shuffled } from './card-copy';

export const ROTATE_MIN_VISIBLE_RATIO = 0.5;
export const ROTATE_MIN_VISIBLE_MS = 1000;
export const ROTATE_INTERVAL_MS = [4000, 6000] as const;

export interface RotateState {
  /** 50% 이상 보이기 시작한 시각(ms) — 안 보이면 null */
  visibleSince: number | null;
  hidden: boolean;
  paused: boolean;
  reducedMotion: boolean;
}

/** 지금 다음 소재로 넘겨도 되는가 */
export function canRotate(s: RotateState, now: number): boolean {
  if (s.hidden || s.paused || s.reducedMotion) return false;
  if (s.visibleSince === null) return false;
  return now - s.visibleSince >= ROTATE_MIN_VISIBLE_MS;
}

/** 시작 소재 번호 — 무작위 */
export function startIndex(count: number, rand: () => number = Math.random): number {
  if (count <= 1) return 0;
  return Math.min(count - 1, Math.floor(rand() * count));
}

/**
 * 로테이터 보여 줄 순서(소재 번호 목록) — 방문마다 유료끼리만 무작위(결제·시작 순서 아님 · Node 10/30 «결제 순차 말고 랜덤»).
 *  유료가 아닌 소재(테스트·하우스)는 유료 뒤에 서버 순서 그대로. 서버 선택(유료 먼저 · 최대 3)은 바꾸지 않는다 — 화면 순서만.
 *  첫 번째가 처음 켜지는 소재. 쿠폰 배너는 로테이터 밖(뒤에 따로)이라 늘 마지막.
 */
export function rotationOrder(paid: readonly boolean[], rand: () => number = Math.random): number[] {
  const p: number[] = [];
  const rest: number[] = [];
  paid.forEach((isPaid, i) => (isPaid ? p : rest).push(i));
  if (p.length === 0) {
    // 유료가 없으면(테스트·하우스만) 종전 그대로 — 서버 순서로 돌되 시작 소재만 무작위.
    const s = startIndex(rest.length, rand);
    return [...rest.slice(s), ...rest.slice(0, s)];
  }
  return [...shuffled(p, rand), ...rest];
}

/** 다음 넘김까지 기다릴 시간(4~6초) */
export function nextDelay(rand: () => number = Math.random): number {
  const [a, b] = ROTATE_INTERVAL_MS;
  return a + Math.floor(rand() * (b - a));
}
